import { render, staticRenderFns } from "./ChartBancos.vue?vue&type=template&id=7dfb62c0&"
import script from "./ChartBancos.vue?vue&type=script&lang=js&"
export * from "./ChartBancos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports